import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../core/service/common-service/common.service'
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatOption } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { DatePipe } from '@angular/common';
import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import { default as _rollupMoment, Moment } from 'moment';
import { FormControl } from '@angular/forms';
import { identity } from 'rxjs';
import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import { Label } from 'ng2-charts';

const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'MMM/YYYY',
  },
  display: {
    dateInput: 'MMM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-prs-dashboard',
  templateUrl: './prs-dashboard.component.html',
  styleUrls: ['./prs-dashboard.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})
export class PrsDashboardComponent implements OnInit {

  uniqueWorkshopCard: string[] = [];
  uniqueWorkshopCardCopy: string[] = [];
  filtersWorkshop: any = [];
  filtersCre: string[] = [];
  spinner: boolean;
  fromDate: Date;
  toDate: Date;
  isDateRangeInvalid = false;
  selectedWorkShop: string[] = [];
  selectedDealer: any;
  uniqueWorkshop: string[] = [];
  uniqueWorkshopCopy: string[] = [];
  dealerCode: string[] = [];
  selectedCre: string[] = [];
  selectedCreCode: any;
  filtersCreCopy: string[] = [];
  creCode: string[] = [];
  userId: string;
  userInfo: any;
  selectedDashboard: any
  availableDashboard: string[] = [];
  defaultLabel: string;
  showLabel: boolean;
  showPrsLabel: boolean;
  allocated: any = {};
  attempted: any = {};
  notAttempted: any = {};
  contacted: any = {};
  notContacted: any = {};
  selectedDate: any;
  date = new FormControl(moment());
  prsRoleId: string="";
  roleId: any="";
  minDate: any = new Date();
  maxDate: any = new Date();
  contactedLanguageBarrier: any = {};
  contactedFollowUp: any = {};
  contactedFullFeedback: any = {};
  contactedSystemRemoved: any = {};
  contactedPartialFeedback: any = {};
  contactedNoFeedback: any = {};
  percContacted: any = {};
  percFeedback: any = {};
  updateChart: boolean;
  prsTopScore: any = {};
  percDealerSatisfied: any = {};
  percDealerDissatisfied: any = {};
  percBothDissatisfied: any = {};
  percBothSatisfied: any = {};
  dlrPrsTopScore: any = {};

  //horizontalBarChart1 horizontalBar start
  public horizontalBarChart1Options: ChartOptions = {
    responsive: true,
    title: { display: false },
    tooltips: {
      enabled: false,
      mode: 'single',
      position: 'nearest',
      caretSize: 2,
      bodyAlign: 'center',
      titleAlign: 'center',
      titleFontSize: 11,
      titleFontStyle: 'normal',
      bodyFontSize: 11,
      bodyFontStyle: 'normal'
    },
    scales: {
      xAxes: [{
        display: false, ticks: {
          beginAtZero: true,
          fontSize: 11
        }
      }],
      yAxes: [{
        display: false, ticks: {
          beginAtZero: true,
          fontSize: 11
        }
      }],
    }
  };
  public horizontalBarChart1Labels: Label[] = ['Attempted'];
  public horizontalBarChartType: ChartType = 'horizontalBar';
  public horizontalBarChartLegend = false;
  public horizontalBarChartPlugins = [];
  public horizontalBarChart1Data: ChartDataSets[] = [];
  //horizontalBarChart1 horizontalBar end

  //horizontalBarChart2 horizontalBar start
  public horizontalBarChart2Labels: Label[] = ['Connected'];
  public horizontalBarChart2Options: ChartOptions = {
    responsive: true,
    title: { display: false },
    tooltips: {
      enabled: false,
      mode: 'single',
      position: 'nearest',
      caretSize: 2,
      bodyAlign: 'center',
      titleAlign: 'center',
      titleFontSize: 11,
      titleFontStyle: 'normal',
      bodyFontSize: 11,
      bodyFontStyle: 'normal'
    },
    scales: {
      xAxes: [{
        display: false, ticks: {
          beginAtZero: true,
          fontSize: 11
        }
      }],
      yAxes: [{
        display: false, ticks: {
          beginAtZero: true,
          fontSize: 11
        }
      }],
    }
  };
  public horizontalBarChart2Data: ChartDataSets[] = [];
  //horizontalBarChart2 horizontalBar end

  //horizontalBarChart3 horizontalBar start
  public horizontalBarChart3Labels: Label[] = ['Feedback'];
  public horizontalBarChart3Options: ChartOptions = {
    responsive: true,
    title: { display: false },
    tooltips: {
      enabled: false,
      mode: 'single',
      position: 'nearest',
      caretSize: 2,
      bodyAlign: 'center',
      titleAlign: 'center',
      titleFontSize: 11,
      titleFontStyle: 'normal',
      bodyFontSize: 11,
      bodyFontStyle: 'normal'
    },
    scales: {
      xAxes: [{
        display: false, ticks: {
          beginAtZero: true,
          fontSize: 11
        }
      }],
      yAxes: [{
        display: false, ticks: {
          beginAtZero: true,
          fontSize: 11
        }
      }],
    }
  };
  public horizontalBarChart3Data: ChartDataSets[] = [];
  //horizontalBarChart3 horizontalBar end

  //horizontalBarChart4 horizontalBar start
  public horizontalBarChart4Options: ChartOptions = {
    responsive: true,
    title: { display: false },
    tooltips: {
      enabled: true,
      mode: 'single',
      position: 'nearest',
      caretSize: 2,
      bodyAlign: 'center',
      titleAlign: 'center',
      displayColors: false,
      titleFontSize: 11,
      titleFontStyle: 'normal',
      bodyFontSize: 11,
      bodyFontStyle: 'normal'
    },
    scales: {
      xAxes: [{
        display: false, ticks: {
          beginAtZero: true,
          fontSize: 11
        }
      }],
      yAxes: [{
        display: true,
        gridLines: { display: false },
        scaleLabel: { display: true },
        ticks: {
          beginAtZero: true,
          fontSize: 11
        }
      }],
    }
  };
  public horizontalBarChart4Labels: Label[] = [
    '% Dissatisfied in Dealer PRS',
    "% Satisfied in Dealer PRS",
    "% Both dissatisfied",
    "% Both Satisfied",
  ];
  public horizontalBarChart4Data: ChartDataSets[] = [];
  //horizontalBarChart4 horizontalBar end
  today: any=new Date();
  noResponse: any = {};
  busy: any = {};
  switchOff: any = {};
  invalid: any = {};
  others: any = {};
  updateChartCard: boolean = false;

  //barChart1 VerticalBar start
  public barChart1Options: ChartOptions = {
    responsive: true,
    title: {
      display: true,
      text: 'Not Contacted Reason',
      position: 'top',
      fontSize: 13
    },
    tooltips: {
      enabled: true,
      mode: 'single',
      position: 'nearest',
      caretSize: 2,
      bodyAlign: 'center',
      titleAlign: 'center',
      displayColors: false,
      titleFontSize: 11,
      titleFontStyle: 'normal',
      bodyFontSize: 11,
      bodyFontStyle: 'normal'
    },
    scales: {
      xAxes: [{
        display: true,
        gridLines: {
          display: false,
        },
        scaleLabel: {
          display: true,
        },
        ticks: {
          beginAtZero: true,
          fontSize: 11
        }
      }],
      yAxes: [{
        display: false,
        ticks: {
          beginAtZero: true,
          fontSize: 11
        }
      }],
    }
  };
  public barChart1Labels: Label[] = ['No Response', 'Busy', 'Switched Off', 'Invalid No.', 'Others'];
  public barChart1Type: ChartType = 'bar';
  public barChart1Legend = false;
  public barChart1Plugins = [];
  public barChart1Data: ChartDataSets[] = [];
  //barChart1 VerticalBar end

  public horizontalBarChart5Options: ChartOptions = {
    responsive: true,
    title: { display: false },
    tooltips: {
      enabled: true,
      mode: 'single',
      position: 'nearest',
      caretSize: 2,
      bodyAlign: 'center',
      titleAlign: 'center',
      displayColors: false,
      titleFontSize: 11,
      titleFontStyle: 'normal',
      bodyFontSize: 11,
      bodyFontStyle: 'normal'
    },
    scales: {
      xAxes: [{
        display: false, ticks: {
          beginAtZero: true,
          fontSize: 11
        }
      }],
      yAxes: [{
        display: true,
        gridLines: { display: false },
        scaleLabel: { display: true },
        ticks: {
          beginAtZero: true,
          fontSize: 11
        }
      }],
    }
  };
  public horizontalBarChart5Labels: Label[] = [
    'Feedback already shared',
    "Vehicle not tested yet",
    "Service not done yet",
    "Customer Disconnect The Call (After Pick)",
    "Customer Not Interested",
    "Incorrect Contact Details",
    "Left the job",
    "Vehicle Returned to showroom"
  ];
  public horizontalBarChart5Data: ChartDataSets[] = [];
  feedbackShared: any={};
  vehicleNotTested: any={};
  serviceNotDone: any={};
  callDisconnect: any={};
  notInterested: any={};
  wrongDetail: any={};
  leftJob: any={};
  vehicleReturn: any={};
  percCallAttempted: any={};


  constructor(private commonService: CommonService, private toastr: ToastrService, private router: Router, private datePipe : DatePipe) {


  }

  ngOnInit() {
    this.setDefaultDates();
    this.prsRoleId="1";
    this.roleId=localStorage.getItem('roleId')

    if(this.roleId=="1"||this.roleId=="15"){
    this.selectedDashboard="Dealer Prs Dashboard"
    }
    this.availableDashboard=[];
    if(this.roleId == "1"){
      this.showLabel=true;
      this.showPrsLabel=true;
      this.availableDashboard.push("SRM Dashboard")
    }
    if(this.roleId == "12"){
      this.showLabel=true;
      this.availableDashboard.push("Dashboard")
    }
    if(this.roleId == "15"){
      this.defaultLabel="Dealer Prs Dashboard"
      this.availableDashboard.push("SRM Dashboard","Call Center Prs Dashboard");
    }
    let userInfo = JSON.parse(localStorage.getItem('userInfo')!);
    this.userInfo = userInfo[0];
    this.userId = localStorage.getItem("userId")!;

    this.filterDashboard();

  }

  onKeyWorkshop() : void {
    this.uniqueWorkshop = this.uniqueWorkshopCopy;
    this.dealerCode = [];
    this.selectedDealer = this.selectedDealer.trim();
    this.dealerCode = this.uniqueWorkshop.filter(item =>
      item.toLowerCase().includes(this.selectedDealer.toLowerCase())
    );
    this.dealerCode.forEach(element => {
      let index = this.uniqueWorkshopCopy.findIndex((ele) => {return ele == element});
      if(index != -1) {
        this.uniqueWorkshopCopy.splice(index, 1);
      }
      this.uniqueWorkshopCopy.unshift(element);
    })
    if(this.dealerCode.length > 0) {
      this.closeInput();
    }
    this.uniqueWorkshop = [];
    this.uniqueWorkshop = this.uniqueWorkshopCopy;
  }

  closeInput() : void {
    if(this.dealerCode.length == 0) {
     this.selectedDealer = '';
     this.uniqueWorkshop = this.uniqueWorkshopCopy;
    }
  }

  onKeyCRE() : void {
    this.filtersCre = this.filtersCreCopy;
    this.creCode = [];
    this.selectedCreCode = this.selectedCreCode.trim();
    this.creCode = this.filtersCre.filter(item =>
      item.toLowerCase().includes(this.selectedCreCode.toLowerCase())
    );
    this.creCode.forEach(element => {
      let index = this.filtersCreCopy.findIndex((ele) => {return ele == element});
      if(index != -1) {
        this.filtersCreCopy.splice(index, 1);
      }
      this.filtersCreCopy.unshift(element);
    })
    if(this.creCode.length > 0) {
      this.closeInputCre();
    }
    this.filtersCre = [];
    this.filtersCre = this.filtersCreCopy;
  }

  closeInputCre() : void {
    if(this.creCode.length == 0) {
     this.selectedCreCode = '';
     this.filtersCre = this.filtersCreCopy;
    }
  }

  dashboardSelection(){
    if(this.selectedDashboard == 'SRM Dashboard'){
      this.prsRoleId='15'
      this.router.navigate(['dashboard']);
    }
    if(this.selectedDashboard == 'Call Center Prs Dashboard'){
      this.availableDashboard.pop();
      this.availableDashboard.push("Dealer Prs Dashboard");
      this.defaultLabel="Call Center Dashboard";
      this.prsRoleId='12';
      this.router.navigate(["prs-dashboard"])
    }
    if(this.selectedDashboard == 'Dealer Prs Dashboard'){
      this.availableDashboard.pop();
      this.availableDashboard.push("Call Center Prs Dashboard");
      this.defaultLabel="Dealer Prs Dashboard";
      this.prsRoleId='1';
      this.router.navigate(["prs-dashboard"])
    }
    this.reset();

  }

  reset() {
    this.selectedCre = [];
    this.selectedWorkShop = [];
    let date = moment(this.maxDate);
    this.date.setValue(date);
    this.setDefaultDates();
    this.isDateRangeInvalid = false;
    this.resetDashboard();
    if(this.prsRoleId=='1'||this.prsRoleId=='12')
    this.filterDashboard();
  }

  filterDashboard(): void {
    this.spinner = true;
    let workshopSet = new Set<string>();
    let workshopCardSet = new Set<string>();
    let roleId;
    if(this.prsRoleId=='12'){
      roleId='12';
    }
    else{
      roleId='15';
    }
    this.commonService.prsFilterDashboard(this.userInfo.userId,roleId).subscribe(
      res => {
        if (res["responseCode"] == 0) {
          this.filtersWorkshop = [];
          this.filtersCre = [];
          res['responseData'].forEach(element => {
            let workshopCode = element.workshop.split(" - ")[0];
            let workshop = { id: element.id, workshopCode: workshopCode, workshop: element.workshop };
            let cre = element.creId;
            this.filtersWorkshop.push(workshop);
            workshopSet.add(workshop.workshop);
            workshopCardSet.add(workshop.workshop);
            if (!this.filtersCre.includes(cre)&& cre!=null) {
              this.filtersCre.push(cre);
            }
          });
          this.selectedDate = this.datePipe.transform(this.date.value['_d'], "MMM yy");
          this.uniqueWorkshop = Array.from(workshopSet);
          this.uniqueWorkshopCard = Array.from(workshopCardSet);
          this.uniqueWorkshopCopy = this.uniqueWorkshop;
          this.uniqueWorkshopCardCopy = this.uniqueWorkshopCard;
          this.filtersCreCopy = this.filtersCre;
          this.getPrsDashboardLeadKpi();
          this.spinner = false;
        } else {
          this.spinner = false;
        }
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });

  }


  resetDashboard(){
    this.allocated = {};
    this.attempted = {};
    this.notAttempted = {};
    this.contacted={};
    this.notContacted={};
    this.percContacted={};
    this.contactedLanguageBarrier={};
    this.contactedFollowUp={};
    this.contactedNoFeedback={};
    this.contactedPartialFeedback={};
    this.contactedFullFeedback={};
    this.contactedSystemRemoved={};
    this.percCallAttempted={}
    this.percFeedback={};
    this.dlrPrsTopScore={};
    this.prsTopScore={};
    this.horizontalBarChart1Data=[];
    this.horizontalBarChart2Data=[];
    this.horizontalBarChart3Data=[];
    this.resetResponseKpi();
    this.resetComparisonKpi();
  }

  resetComparisonKpi(){
    this.horizontalBarChart4Data=[];
  }

  resetResponseKpi(){
    this.barChart1Data=[];
    this.horizontalBarChart5Data = [];
  }

  getPrsDashboardLeadKpi(){
    if (this.isDateRangeInvalid) {
      this.toastr.error("Please select dates within a 30-day range to proceed.", "Error");
      return;
    }
    this.spinner = true;
    let selectedCre = '';
    this.selectedCre.forEach((element, index) => {
      if (index == 0) {
        selectedCre = element;
      } else {
        selectedCre = selectedCre + ',' + element;
      }
    });
    let selectedWorkShop = '';
    this.selectedWorkShop.forEach((element, index) => {
      if (index == 0) {
        selectedWorkShop = element.split(" - ")[0];
      } else {
        selectedWorkShop = selectedWorkShop + ',' + element.split(" - ")[0];
      }
    });
    const request = {
      "userId": this.userInfo.userId,
      "roleId": this.userInfo.roleId,
      "creId": selectedCre || '',
      "workshopCode": selectedWorkShop || '',
      "PrsRoleId": this.prsRoleId,
      "startDate": this.datePipe.transform(this.fromDate, "yyyy-MM-dd").toString(),
      "endDate": this.datePipe.transform(this.toDate, "yyyy-MM-dd").toString()
    };
    this.resetDashboard();
    this.commonService.getPrsDashboardLeadKpi(request).subscribe(
      res => {
        if (res["responseCode"] == 0) {
          this.selectedDate = this.datePipe.transform(this.date.value['_d'], "MMM yy");
          res["responseData"].forEach(kpi => {
            if (kpi.actualVal) {
              kpi.actualVal = Math.round(kpi.actualVal * 100 + Number.EPSILON) / 100;
            }
            if (kpi.kpiCode == '001') {
              this.allocated = kpi;
            }
            if (kpi.kpiCode == '002') {
              this.attempted = kpi;
            }
            if (kpi.kpiCode == '003') {
              this.notAttempted = kpi;
            }
            if (kpi.kpiCode == '004') {
              this.contacted = kpi;
            }
            if (kpi.kpiCode == '005') {
              this.notContacted = kpi;
            }
            if (kpi.kpiCode == '006') {
              this.percCallAttempted = kpi;
            }
            if (kpi.kpiCode == '007') {
              this.percFeedback = kpi;
            }
            if (kpi.kpiCode == '008') {
              this.dlrPrsTopScore = kpi;
            }
            if (kpi.kpiCode == '009') {
              this.prsTopScore = kpi;
            }
            if (kpi.kpiCode == '010') {
              this.contactedLanguageBarrier = kpi;
            }
            if (kpi.kpiCode == '011') {
              this.contactedFollowUp = kpi;
            }
            if (kpi.kpiCode == '012') {
              this.contactedFullFeedback = kpi;
            }
            if (kpi.kpiCode == '013') {
              this.contactedPartialFeedback = kpi;
            }
            if (kpi.kpiCode == '014') {
              this.contactedNoFeedback = kpi;
            }
            if (kpi.kpiCode == '015') {
              this.contactedSystemRemoved = kpi;
            }
            if (kpi.kpiCode == '016') {
              this.percDealerDissatisfied = kpi;
            }
            if (kpi.kpiCode == '017') {
              this.percDealerSatisfied = kpi;
            }
            if (kpi.kpiCode == '018') {
              this.percBothDissatisfied = kpi;
            }
            if (kpi.kpiCode == '019') {
              this.percBothSatisfied = kpi;
            }
            if (kpi.kpiCode == '020') {
              this.percContacted = kpi;
            }
            this.spinner = false;
          });

          //horizontalBarChart1 start
          this.contacted.actualVal = this.contacted.actualVal || 0;
          this.notContacted.actualVal = this.notContacted.actualVal || 0;
          if (this.contacted.actualVal || this.notContacted.actualVal) {
            this.horizontalBarChart1Data = [
              {
                data: [this.contacted.actualVal],
                stack: 'a',
                label: 'Contacted',
                backgroundColor: 'rgb(46, 54, 104)',
                hoverBackgroundColor: 'rgb(46, 54, 104)',
                borderSkipped: 'chartArea',
                barPercentage: 0.5,
                barThickness: 12,
                maxBarThickness: 12,
                minBarLength: 2
              },
              {
                data: [this.notContacted.actualVal],
                stack: 'a',
                label: 'Not Contacted',
                backgroundColor: 'rgb(87, 174, 239)',
                hoverBackgroundColor: 'rgb(87, 174, 239)',
                borderSkipped: 'chartArea',
                barPercentage: 0.5,
                barThickness: 12,
                maxBarThickness: 12,
                minBarLength: 2
              }
            ];
            let max1 = this.contacted.actualVal + this.notContacted.actualVal;
            this.horizontalBarChart1Options.scales.xAxes[0].ticks.max = max1;
            this.horizontalBarChart1Options.scales.yAxes[0].ticks.max = max1;
          }
          //horizontalBarChart1 end

          //horizontalBarChart2 start
          this.contactedLanguageBarrier.actualVal = this.contactedLanguageBarrier.actualVal || 0;
          this.contactedFollowUp.actualVal = this.contactedFollowUp.actualVal || 0;
          this.contactedSystemRemoved.actualVal = this.contactedSystemRemoved.actualVal || 0;
          this.contactedFullFeedback.actualVal = this.contactedFullFeedback.actualVal || 0;
          this.contactedNoFeedback.actualVal = this.contactedNoFeedback.actualVal || 0;
          this.contactedPartialFeedback.actualVal = this.contactedPartialFeedback.actualVal || 0;
          let max2 = this.contactedLanguageBarrier.actualVal + this.contactedFollowUp.actualVal
           + this.contactedSystemRemoved.actualVal
            + this.contactedFullFeedback.actualVal + this.contactedNoFeedback.actualVal + this.contactedPartialFeedback.actualVal;
          if (max2) {
            this.horizontalBarChart2Options.scales.xAxes[0].ticks.max = max2;
            this.horizontalBarChart2Options.scales.yAxes[0].ticks.max = max2;
            this.horizontalBarChart2Data = [
              {
                data: [this.contactedLanguageBarrier.actualVal],
                stack: 'a',
                label: 'Language Barrier',
                backgroundColor: '#4834d4',
                hoverBackgroundColor: '#4834d4',
                borderSkipped: 'chartArea',
                barPercentage: 0.5,
                barThickness: 12,
                maxBarThickness: 12,
                minBarLength: 2
              },
              {
                data: [this.contactedFollowUp.actualVal],
                stack: 'a',
                label: 'Followup',
                backgroundColor: '#57aeef',
                hoverBackgroundColor: '#57aeef',
                borderSkipped: 'chartArea',
                barPercentage: 0.5,
                barThickness: 12,
                maxBarThickness: 12,
                minBarLength: 2
              },
              {
                data: [this.contactedSystemRemoved.actualVal],
                stack: 'a',
                label: 'System Closed',
                backgroundColor: '#5758bb',
                hoverBackgroundColor: '#5758bb',
                borderSkipped: 'chartArea',
                barPercentage: 0.5,
                barThickness: 12,
                maxBarThickness: 12,
                minBarLength: 2
              },
              {
                data: [this.contactedPartialFeedback.actualVal],
                stack: 'a',
                label: 'Partial Feedback',
                backgroundColor: '#00008B',
                hoverBackgroundColor: '#00008B',
                borderSkipped: 'chartArea',
                barPercentage: 0.5,
                barThickness: 12,
                maxBarThickness: 12,
                minBarLength: 2
              },
              {
                data: [this.contactedNoFeedback.actualVal],
                stack: 'a',
                label: 'No Feedback',
                backgroundColor: '#3f729d',
                hoverBackgroundColor: '#3f729d',
                borderSkipped: 'chartArea',
                barPercentage: 0.5,
                barThickness: 12,
                maxBarThickness: 12,
                minBarLength: 2
              },
              {
                data: [this.contactedFullFeedback.actualVal],
                stack: 'a',
                label: 'Full Feedback',
                backgroundColor: '#2e3668',
                hoverBackgroundColor: '#2e3668',
                borderSkipped: 'chartArea',
                barPercentage: 0.5,
                barThickness: 12,
                maxBarThickness: 12,
                minBarLength: 2
              }
            ];
          }
          //horizontalBarChart2 end

          //horizontalBarChart3 start
          this.dlrPrsTopScore.actualVal = this.dlrPrsTopScore.actualVal || 0;
          this.prsTopScore.actualVal = this.prsTopScore.actualVal || 0;
          let max3 = this.dlrPrsTopScore.actualVal + this.prsTopScore.actualVal;
          if (max3) {
            this.horizontalBarChart3Options.scales.xAxes[0].ticks.max = max3;
            this.horizontalBarChart3Options.scales.yAxes[0].ticks.max = max3;
            this.horizontalBarChart3Data = [
              {
                data: [this.dlrPrsTopScore.actualVal],
                stack: 'a',
                label: 'Active',
                backgroundColor: '#2e3668',
                hoverBackgroundColor: '#2e3668',
                borderSkipped: 'chartArea',
                barPercentage: 0.5,
                barThickness: 12,
                maxBarThickness: 12,
                minBarLength: 2
              },

              {
                data: [this.prsTopScore.actualVal],
                stack: 'a',
                label: 'No Service',
                backgroundColor: '#4834d4',
                hoverBackgroundColor: '#4834d4',
                borderSkipped: 'chartArea',
                barPercentage: 0.5,
                barThickness: 12,
                maxBarThickness: 12,
                minBarLength: 2
              },
            ];
          }
          //horizontalBarChart3 end
          this.getPrsDashboardResponseKpi(request);
          if(this.roleId!="12"&&this.prsRoleId!="12")
          this.getComparisonLead(request);
          this.updateChart = false

        }
        else {
          this.toastr.error(res["message"])
          this.spinner = false
          this.updateChart = false
        }
      }, err => {
        this.spinner = false;
        this.updateChart = false
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  getComparisonLead(request) {
    let req=request;
    this.commonService.getPrsDashboardComparisonKpi(req).subscribe(
      res => {
        if (res["responseCode"] == 0) {
          this.selectedDate = this.datePipe.transform(this.date.value['_d'], "MMM yy");
          res["responseData"].forEach(kpi => {
            if (kpi.actualVal) {
              kpi.actualVal = Math.round(kpi.actualVal * 100 + Number.EPSILON) / 100;
            }
            if (kpi.kpiCode == '016') {
              this.percDealerDissatisfied = kpi;
            }
            if (kpi.kpiCode == '017') {
              this.percDealerSatisfied = kpi;
            }
            if (kpi.kpiCode == '018') {
              this.percBothDissatisfied = kpi;
            }
            if (kpi.kpiCode == '019') {
              this.percBothSatisfied = kpi;
            }
            this.spinner = false;
          });
          //horizontalBarChart4 start Rating Comparison
          this.percDealerDissatisfied.actualVal = this.percDealerDissatisfied.actualVal || 0;
          this.percDealerSatisfied.actualVal = this.percDealerSatisfied.actualVal || 0;
          this.percBothDissatisfied.actualVal = this.percBothDissatisfied.actualVal || 0;
          this.percBothSatisfied.actualVal = this.percBothSatisfied.actualVal || 0;
          let max4 = Math.max(this.percDealerDissatisfied.actualVal, this.percDealerSatisfied.actualVal, this.percBothDissatisfied.actualVal,
            this.percBothSatisfied.actualVal);
          if (max4) {
            this.horizontalBarChart4Options.scales.xAxes[0].ticks.max = max4 + 10;
            this.horizontalBarChart4Options.scales.yAxes[0].ticks.max = max4 + 10;
            this.horizontalBarChart4Data = [
              {
                data: [this.percDealerDissatisfied.actualVal, this.percDealerSatisfied.actualVal, this.percBothDissatisfied.actualVal,
                this.percBothSatisfied.actualVal],
                backgroundColor: 'rgb(46, 54, 104)',
                hoverBackgroundColor: 'rgb(46, 54, 104)',
                borderSkipped: 'chartArea',
                barPercentage: 0.5,
                barThickness: 10,
              }
            ];
          }
          //horizontalBarChart4 end
          this.spinner=false;
          this.updateChartCard = false;
        }
        else {
          this.toastr.error(res["message"])
          this.spinner = false
          this.updateChartCard = false;
        }
      }, err => {
        this.spinner = false;
        this.updateChartCard = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  getPrsDashboardResponseKpi(request){
    let req=request;
    this.commonService.getPrsDashboardResponseKpi(req).subscribe(
      res => {
        if (res["responseCode"] == 0) {
          this.selectedDate = this.datePipe.transform(this.date.value['_d'], "MMM yy");
          res["responseData"].forEach(kpi => {
            if (kpi.actualVal) {
              kpi.actualVal = Math.round(kpi.actualVal * 100 + Number.EPSILON) / 100;
            }
            if (kpi.kpiCode == '205') {
              this.noResponse = kpi;
            }
            if (kpi.kpiCode == '206') {
              this.busy = kpi;
            }
            if (kpi.kpiCode == '207') {
              this.switchOff = kpi;
            }
            if (kpi.kpiCode == '208') {
              this.invalid = kpi;
            }
            if (kpi.kpiCode == '209') {
              this.others = kpi;
            }
            if (kpi.kpiCode == '318') {
              this.feedbackShared = kpi;
            }
            if (kpi.kpiCode == '319') {
              this.vehicleNotTested = kpi;
            }
            if (kpi.kpiCode == '320') {
              this.serviceNotDone = kpi;
            }
            if (kpi.kpiCode == '321') {
              this.callDisconnect = kpi;
            }
            if (kpi.kpiCode == '322') {
              this.notInterested = kpi;
            }
            if (kpi.kpiCode == '323') {
              this.wrongDetail = kpi;
            }
            if (kpi.kpiCode == '327') {
              this.leftJob = kpi;
            }
            if (kpi.kpiCode == '328') {
              this.vehicleReturn = kpi;
            }
          });
           //barChart1 start not connected reason
           this.noResponse.actualVal = this.noResponse.actualVal || 0;
           this.busy.actualVal = this.busy.actualVal || 0;
           this.switchOff.actualVal = this.switchOff.actualVal || 0;
           this.invalid.actualVal = this.invalid.actualVal || 0;
           this.others.actualVal = this.others.actualVal || 0;
           let maxNotConnected = Math.max(this.noResponse.actualVal, this.busy.actualVal, this.switchOff.actualVal, this.invalid.actualVal, this.others.actualVal);
           if (maxNotConnected) {
             this.barChart1Options.scales.xAxes[0].ticks.max = maxNotConnected;
             this.barChart1Options.scales.yAxes[0].ticks.max = maxNotConnected;
             this.barChart1Data = [
               {
                 data: [this.noResponse.actualVal, this.busy.actualVal, this.switchOff.actualVal, this.invalid.actualVal, this.others.actualVal],
                 backgroundColor: 'rgb(87, 174, 239)',
                 hoverBackgroundColor: 'rgb(87, 174, 239)',
                 borderSkipped: 'chartArea',
                 barPercentage: 0.5,
                 barThickness: 20,
                 maxBarThickness: 20,
                 minBarLength: 2
               }
             ];
           }
           //barChart1 end

           //horizontalBarChart5 start noservice booking
          this.feedbackShared.actualVal = this.feedbackShared.actualVal || 0;
          this.vehicleNotTested.actualVal = this.vehicleNotTested.actualVal || 0;
          this.serviceNotDone.actualVal = this.serviceNotDone.actualVal || 0;
          this.callDisconnect.actualVal = this.callDisconnect.actualVal || 0;
          this.notInterested.actualVal = this.notInterested.actualVal || 0;
          this.wrongDetail.actualVal = this.wrongDetail.actualVal || 0;
          this.leftJob.actualVal = this.leftJob.actualVal || 0;
          this.vehicleReturn.actualVal = this.vehicleReturn.actualVal || 0;
          let max5 = Math.max(this.feedbackShared.actualVal, this.vehicleNotTested.actualVal, this.serviceNotDone.actualVal,
            this.callDisconnect.actualVal, this.notInterested.actualVal, this.wrongDetail.actualVal,
           this.leftJob.actualVal,this.vehicleReturn.actualVal
           );
          if (max5) {
            this.horizontalBarChart5Options.scales.xAxes[0].ticks.max = max5 + 10;
            this.horizontalBarChart5Options.scales.yAxes[0].ticks.max = max5 + 10;
            this.horizontalBarChart5Data = [
              {
                data: [this.feedbackShared.actualVal, this.vehicleNotTested.actualVal, this.serviceNotDone.actualVal,
                  this.callDisconnect.actualVal, this.notInterested.actualVal, this.wrongDetail.actualVal,
                 this.leftJob.actualVal, this.vehicleReturn.actualVal
                ],
                backgroundColor: 'rgb(46, 54, 104)',
                hoverBackgroundColor: 'rgb(46, 54, 104)',
                borderSkipped: 'chartArea',
                barPercentage: 0.5,
                barThickness: 10,
              }
            ];
          }

           this.updateChartCard = false;
          this.spinner=false
        }
        else{
          this.updateChartCard = false;
          this.spinner=false
        }
      }, err => {
        this.spinner = false;
        this.updateChartCard = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  setDefaultDates() {
    const current = new Date();
    this.fromDate = new Date(current.getFullYear(), current.getMonth(), 1); // 1st of current month
    this.toDate = this.today; // Today's date
  }

  // Validate the date range to restrict to 30 days
  validateDateRange(type: 'from' | 'to') {
    const thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000;
    if (type === 'from') {
      const maxToDate = new Date(this.fromDate.getTime() + thirtyDaysInMs);
      if (this.toDate.getTime() > maxToDate.getTime()) {
        this.isDateRangeInvalid = true;
      } else {
        this.isDateRangeInvalid = false;
      }
    } else if (type === 'to') {
      const minFromDate = new Date(this.toDate.getTime() - thirtyDaysInMs);
      if (this.fromDate.getTime() < minFromDate.getTime()) {
        this.isDateRangeInvalid = true;
      } else {
        this.isDateRangeInvalid = false;
      }
    }
  }
}